export const state = () => ({
	isOpen: false
});

export const mutations = {
	setOpen: function (state, value) {
		state.isOpen = value;
	}
};